import { Plane, TrainFront, Anchor, Factory, Cog } from "lucide-react";
import { Reveal } from "../Reveal";

const SECTOR_ICONS = { "Aéronautique": Plane, "Ferroviaire": TrainFront, "Naval": Anchor, "Industrie": Factory };

export default function ProfileJourney({ experiences }) {
  if (!experiences?.length) return null;
  return (
    <section id="parcours" className="bg-ink-950 text-paper grain relative py-24 md:py-32 overflow-hidden" data-testid="profile-journey">
      <div className="absolute -right-24 bottom-0 w-[460px] h-[460px] rounded-full bg-gold/8 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <span className="label-mono text-gold">04 — Expérience terrain</span>
          <h2 className="font-display text-4xl md:text-6xl font-semibold mt-4 tracking-tight max-w-4xl">Plus de dix ans au cœur des environnements industriels.</h2>
        </Reveal>
        <div className="mt-16 relative border-l border-paper/15 pl-10 md:pl-14 space-y-12 max-w-3xl">
          {experiences.map((e, i) => {
            const Icon = SECTOR_ICONS[e.sector] || Cog;
            return (
              <Reveal key={`${e.sector}-${i}`} delay={0.05 * i}>
                <article className="relative" data-testid={`journey-item-${i}`}>
                  <div className="absolute -left-[59px] md:-left-[75px] top-0 w-10 h-10 rounded-full bg-ink-900 border border-gold/40 text-gold flex items-center justify-center">
                    <Icon size={17} />
                  </div>
                  <span className="label-mono text-gold">{e.sector}</span>
                  <h3 className="font-display text-2xl font-semibold mt-2">{e.role || e.sector}</h3>
                  {e.period && <div className="label-mono text-paper/40 mt-1.5">{e.period}</div>}
                  {e.context && <p className="text-paper/65 leading-relaxed mt-3 max-w-2xl">{e.context}</p>}
                  {e.missions?.length > 0 && (
                    <ul className="mt-4 space-y-2">
                      {e.missions.map((m) => (
                        <li key={m} className="flex items-start gap-2.5 text-paper/60 text-sm">
                          <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-gold/70 shrink-0" />{m}
                        </li>
                      ))}
                    </ul>
                  )}
                  {e.methods?.length > 0 && (
                    <div className="flex flex-wrap gap-2 mt-4">
                      {e.methods.map((m) => (
                        <span key={m} className="label-mono px-3 py-1.5 rounded-full border border-paper/20 text-paper/70">{m}</span>
                      ))}
                    </div>
                  )}
                  {e.results && <p className="text-gold/90 text-sm mt-4">{e.results}</p>}
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
